export default __webpack_public_path__ + "static/media/Thief's Boots of the Burning Temple.84bbaee0.jpg";